/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .more[_ngcontent-%COMP%]{color:#3bc7f5}[_nghost-%COMP%]   .more[_ngcontent-%COMP%]:hover{text-decoration:underline}"];
export { styles as styles };
